import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import axios from "axios";
import "./RegisterPage.css";
const RegisterPage = () => {
  const [averageError, setAverageError] = useState("");
  const [university, setUniversity] = useState([]);
  const [nationalities, setNationalities] = useState([]);
  const [specialization, setSpecialization] = useState([]);
  const [colleges, setColleges] = useState([]);
  const [selectedCourses, setSelectedCourses] = useState([]);
  const [selectedCollege, setSelectedCollege] = useState([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(false);
  const [hasJob, setHasJob] = useState("");

  const [step, setStep] = useState(1);
  const [formDatas, setFormData] = useState({});

  const navigate = useNavigate();

  const fetchColleges = async () => {
    try {
      const response = await axios.get(
        `https://portal.mjc.edu.sa/v1/registrations`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response.data.data);
      setColleges(response.data.data);
    } catch (error) {
      console.error("حدث خطأ في جلب البيانات:", error);
    }
  };

  const fetchUniversity = async () => {
    try {
      const response = await axios.get(
        "https://portal.mjc.edu.sa/v1/education",
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setUniversity(response.data.data.universities);
      setSpecialization(response.data.data.specializations);
    } catch (error) {
      console.error("حدث خطأ في جلب البيانات:", error);
    }
  };

  const fetchNationalities = async () => {
    try {
      const response = await axios.get(
        "https://portal.mjc.edu.sa/api/nationalities",
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      setNationalities(response.data.data.nationalities);
      console.log(response.data.data.nationalities);
    } catch (error) {
      console.error("حدث خطأ في جلب البيانات:", error);
    }
  };

  useEffect(() => {
    fetchUniversity();
    fetchColleges();
    fetchNationalities();
  }, []);

  const handleNextStep = async (e) => {
    e.preventDefault();

    const form = document.querySelector("form");
    const formData = new FormData(form);
    const data = Object.fromEntries(formData.entries());

    if (step === 1) {
      const requiredFields = [
        "first_name",
        "last_name",
        "gender",
        "phone",
        "email",
        "id_number",
        "id_place",
        "birth_date",
        "Health_status",
        "nationalities",
      ];

      const missing = requiredFields.filter(
        (field) => !data[field] || data[field].trim() === ""
      );

      if(formDatas.gender === "m"){
        if(!formDatas.personal_photo){
          toast.error("يرجى إرفاق الصورة الشخصية");
          return;
        }
      }


      if(hasJob === "yes"){
        if(!formDatas.work_permission){
          toast.error("يرجى إرفاق مرفق باسم موافقة جهة العمل");
          return;
        }
      }


      if (missing.length > 0) {
        toast.error("يرجى ملء جميع الحقول المطلوبة للمتابعة");
        return;
      }

      

      try {
        const response = await axios.post(
          "https://portal.mjc.edu.sa/api/checking",
          {
            id_number: formDatas.id_number,
            phone: formDatas.phone,
          },
          {
            headers: {
              "Content-Type": "application/json",
            },

          }
        );

        const result = response.data;

        if (result.code === 800) {
          if (result.data.id_number === false || result.data.phone === false) {
            toast.error("رقم الهوية أو الهاتف مسجل مسبقاً");
            return;
          }

          setFormData((prev) => ({ ...prev, ...formDatas }));
          setStep(2);
        } else {
          toast.error("حدث خطأ أثناء التحقق من البيانات.");
        }
      } catch (error) {
        toast.error("فشل الاتصال بالخادم.");
        console.error("API error:", error);
      }
    } else if (step === 2) {
      const requiredFields = ["average", "qualification_type"];

      if (formDatas.qualification_type === "secondary") {
        if (!formDatas.file) {
          toast.error("يرجى إرفاق مستندات الاختبار التحصيلي  ");
          return;
        }
        if (!formDatas.ability) {
          toast.error("يرجى إرفاق مستندات اختبار القدرات");
          return;
        }
        if (!formDatas.hs_cert_picture_id) {
          toast.error("يرجى  إرفاق مستندات الثانوية العامة");
          return;
        }
      }

      if (formDatas.qualification_type === "university") {
        if (!formDatas.university_document) {
          toast.error("يرجى إرفاق الشهاده الجامعيه  ");
          return;
        }
        if (!formDatas.academia_document) {
          toast.error("يرجى إرفاق السجل الاكاديمي");
          return;
        }
        // if (!formDatas.supjects_desc) {
        //   toast.error("يرجى  إرفاق وصف المقررات");
        //   return;
        // }
      }
      const missing = requiredFields.filter((field) => {
        const value = data[field];
        if (value === undefined || value === null) return true;

        if (typeof value === "string" && value.trim() === "") return true;

        if (value instanceof File && value.size === 0) return true;

        return false;
      });

      if (missing.length > 0) {
        toast.error("يرجى ملء جميع الحقول المطلوبة للمتابعة");
        return;
      }

      const file = formDatas.file;
      const ability = formDatas.ability;
      const hs_cert_picture_id = formDatas.hs_cert_picture_id;
      const university_document = formDatas.university_document;
      const academia_document = formDatas.academia_document;
      const supjects_desc = formDatas.supjects_desc ?? null;
      const financial_document = formDatas.financial_document;
      const medical_document = formDatas.medical_document;
      const personal_photo = formDatas.personal_photo;

      setFormData((prev) => ({
        ...prev,
        ...data,
        file,
        ability,
        hs_cert_picture_id,
        university_document,
        academia_document,
        supjects_desc,
        financial_document,
        personal_photo,
      }));

      setStep(3);
    }
    if (step === 3 && !acceptedTerms) {
      toast.error("يرجى الموافقة على الشروط والأحكام قبل الإرسال");
      return;
    }
  };

  const validateAverage = (e) => {
    const value = parseFloat(e.target.value);

    if (!value || value < 0.1 || value > 5) {
      setAverageError("يجب أن يكون المعدل بين 0.1 و 5.");
    } else {
      setAverageError("");
    }
  };

  const handleAddCollege = () => {
    if (!selectedCollege) return;

    const selected = colleges.find((c) => c.id === parseInt(selectedCollege));

    if (!selected) return;

    if (selectedCourses.find((c) => c.id === selected.id)) {
      toast.error("تم اختيار هذه الكلية من قبل.");
      return;
    }

    if (selectedCourses.length >= 3) {
      toast.error("يمكنك اختيار 3 كليات فقط.");
      return;
    }

    setSelectedCourses([...selectedCourses, selected]);
    setSelectedCollege("");
  };

  const handleRemoveCollege = (courseId) => {
    console.log(courseId);
    setSelectedCourses((prev) => prev.filter((c) => c.id !== courseId));
  };

  const handleCollegeSelection = (e) => {
    const selectedOptions = Array.from(e.target.selectedOptions);

    if (selectedOptions.length > 3) {
      toast.error("يمكنك اختيار 3 كليات فقط.");
      return;
    }

    const selections = selectedOptions.map((opt) => {
      const courseId = parseInt(opt.value);
      const college = colleges.find((c) => c.course_id === courseId);
      return {
        course_id: college.course_id,
        register_id: college.id,
      };
    });

    setSelectedCourses(selections);
  };

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = (error) => reject(error);
    });

  const fileToBase64Object = async (file) => {
    const base64Data = await toBase64(file);
    return {
      filename: file.name,
      data: base64Data,
    };
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    if (selectedCourses.length < 2) {
      toast.error("يجب اختيار رغبتين أو أكثر قبل الإرسال");
      setIsSubmitting(false);
      return;
    }

    const formData = new FormData(e.target);
    const data = Object.fromEntries(formData.entries());

    const file = formDatas.file;
    const ability = formDatas.ability;
    const hs_cert = formDatas.hs_cert_picture_id;
    const university_document = formDatas.university_document;
    const academia_document = formDatas.academia_document;
    const supjects_desc = formDatas.supjects_desc;
    const financial_document = formDatas.financial_document;
    const medical_document = formDatas.medical_document;
    const personal_photo = formDatas.personal_photo;
    const work_permission = formDatas.work_permission;

    let fileObject = null;
    let abilityObject = null;
    let hsCertObject = null;
    let universityDocumentObject = null;
    let academiaDocumentObject = null;
    let supjectsDescObject = null;
    let financialDocumentObject = null;
    let medicalDocumentObject = null;
    let personalPhotoObject = null;
    let workPermissionObject = null;

    if (file && file.size > 0) {
      fileObject = await fileToBase64Object(file);
    }

    if (ability && ability.size > 0) {
      abilityObject = await fileToBase64Object(ability);
    }

    if (hs_cert && hs_cert.size > 0) {
      hsCertObject = await fileToBase64Object(hs_cert);
    }

    if (university_document && university_document.size > 0) {
      universityDocumentObject = await fileToBase64Object(university_document);
    }

    if (academia_document && academia_document.size > 0) {
      academiaDocumentObject = await fileToBase64Object(academia_document);
    }

    if (supjects_desc && supjects_desc.size > 0) {
      supjectsDescObject = await fileToBase64Object(supjects_desc);
    }

    if (financial_document && financial_document.size > 0) {
      financialDocumentObject = await fileToBase64Object(financial_document);
    }

    if (medical_document && medical_document.size > 0) {
      medicalDocumentObject = await fileToBase64Object(medical_document);
    }

    if (personal_photo && personal_photo.size > 0) {
      personalPhotoObject = await fileToBase64Object(personal_photo);
    }

    if (work_permission && work_permission.size > 0) {
      workPermissionObject = await fileToBase64Object(work_permission);
    }

    const courseIds = selectedCourses.map((item) => item.course_id);
    const registerIds = selectedCourses.map((item) => item.id);

    console.log(registerIds);
    console.log(formDatas.nationalities);
    const payload = {
      first_name: formDatas.first_name,
      middle_name: formDatas.middle_name,
      last_name: formDatas.last_name,
      first_name_en: formDatas.first_name_en,
      middle_name_en: formDatas.middle_name_en,
      last_name_en: formDatas.last_name_en,
      fourth_name : formDatas.fourth_name,
      fourth_name_en: formDatas.fourth_name_en,
      gender: formDatas.gender,
      birth_date: formDatas.birth_date,
      email: formDatas.email,
      phone: formDatas.phone,
      id_number: formDatas.id_number,
      id_place: formDatas.id_place,
      qualification: formDatas.qualification,
      qualification_type: formDatas.qualification_type,
      hs_educational_area: formDatas.school,
      school_year: formDatas.graduation_date,
      pg_type: formDatas.pg_type,
      pg_cgpa: formDatas.average,
      nationality: formDatas.nationalities,
      summative_assessment: formDatas.summative_assessment,
      hs_cgpa: formDatas.average,
      qualification_from: formDatas.Qualification_awarding,
      appreciation: formDatas.appreciation,
      ability_grade: formDatas.ability_grade,
      specialization_id: formDatas.specialization,
      university_id: formDatas.university,
      ability_test_picture_id: abilityObject,
      summative_assessment_picture_id: fileObject,
      hs_cert_picture_id: hsCertObject,
      Health_status: formDatas.Health_status,
      university_document: universityDocumentObject,
      academia_document: academiaDocumentObject,
      supjects_desc: supjectsDescObject,
      medical_document: medicalDocumentObject,
      personal_photo: personalPhotoObject,
      register_id: registerIds,
      course_id: courseIds,
      work_permission: workPermissionObject,
    };

    console.log(payload);
    const commonData = { ...payload };
    delete commonData.register_id;
    delete commonData.course_id;

    try {
      const response = await fetch("https://portal.mjc.edu.sa/v1/web/json", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      });


      const data = await response.json();

      setIsSubmitting(false);
      if (response.ok) {
        if (data.code === 801) {
          const commonData = {};
          formData.forEach((value, key) => {
            if (key !== "file") {
              commonData[key] = value;
            }
          });

          toast.success(
            "تم تسجيل طلبك بنجاح سيتم إرسال التفاصيل في البريد الإلكتروني المرفق مع الطلب"
          );

          window.location = "/success"
          // setTimeout(() => (window.location = "/success"), 3000);
        } else {
          toast.error("فشل التسجيل: حدث خطأ ما.");
        }
      } else {
        toast.error(`فشل التسجيل: ${data.message || "حدث خطأ ما."}`);
      }
    } catch (error) {
      console.error("Network error:", error);
      toast.error("خطأ في الاتصال بالخادم!");
    }
  };

  return (
    <>
      <div className="container py-5" dir="rtl">
        <h2 className="text-center mb-5">التقديم في الكلية</h2>
        <div className="steps-progress d-flex justify-content-center align-items-center mb-5">
          {["البيانات الشخصية", "البيانات الدراسية", "تفاصيل الرغبات"].map(
            (label, index) => {
              const currentStep = index + 1;
              const isCompleted = step > currentStep;
              const isActive = step === currentStep;

              let statusClass = "";
              if (isCompleted) statusClass = "completed";
              else if (isActive) statusClass = "active";
              else statusClass = "upcoming";

              return (
                <div
                  key={index}
                  className="step-item d-flex flex-column align-items-center mx-3 text-center me-2"
                >
                  <div className={`bubble ${statusClass}`}>
                    {currentStep}
                    <div className="arrow-down" />
                  </div>
                  <small className={`label ${statusClass}`}>{label}</small>
                </div>
              );
            }
          )}
        </div>

        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="row">
            {step === 1 && (
              <>
                <h4
                  style={{
                    background: "#304E50",
                    padding: "10px",
                    color: "#fff",
                  }}
                >
                  البيانات الشخصية
                </h4>
                <div className="col-12 col-lg-3 mb-3 mt-4">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    الاسم الأول
                  </label>
                  <input
                    type="text"
                    name="first_name"
                    className="form-control"
                    required
                    value={formDatas.first_name || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        first_name: e.target.value,
                      }))
                    }
                  />
                </div>


                <div className="col-12 col-lg-3 mb-3 mt-4">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    الاسم الأوسط
                  </label>
                  <input
                    type="text"
                    name="middle_name"
                    className="form-control"
                    value={formDatas.middle_name || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        middle_name: e.target.value,
                      }))
                    }
                  />
                </div>


            

                <div className="col-12 col-lg-3 mb-3 mt-4">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    الاسم الثالث
                  </label>
                  <input
                    type="text"
                    name="last_name"
                    className="form-control"
                    required
                    value={formDatas.last_name || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        last_name: e.target.value,
                      }))
                    }
                  />
                </div>


                <div className="col-12 col-lg-3 mb-3 mt-4">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    الاسم الرابع
                  </label>
                  <input
                    type="text"
                    name="fourth_name"
                    className="form-control"
                    required
                    value={formDatas.fourth_name || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        fourth_name: e.target.value,
                      }))
                    }
                  />
                </div>

 <div
                  className="col-12 col-lg-3 mb-3 mt-4"
                  style={{ direction: "ltr" }}
                >
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    Fourth name
                  </label>
                  <input
                    type="text"
                    name="fourth_name_en"
                    className="form-control"
                    required
                    value={formDatas.fourth_name_en || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        fourth_name_en: e.target.value,
                      }))
                    }
                  />
                </div>


                <div
                  className="col-12 col-lg-3 mb-3 mt-4"
                  style={{ direction: "ltr" }}
                >
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    The third name
                  </label>
                  <input
                    type="text"
                    name="last_name_en"
                    className="form-control"
                    required
                    value={formDatas.last_name_en || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        last_name_en: e.target.value,
                      }))
                    }
                  />
                </div>


                <div
                  className="col-12 col-lg-3 mb-3 mt-4"
                  style={{ direction: "ltr" }}
                >
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    Middle name
                  </label>
                  <input
                    type="text"
                    name="middle_name_en"
                    className="form-control"
                    value={formDatas.middle_name_en || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        middle_name_en: e.target.value,
                      }))
                    }
                  />
                </div>

                <div
                  className="col-12 col-lg-3 mb-3 mt-4"
                  style={{ direction: "ltr" }}
                >
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    First name
                  </label>
                  <input
                    type="text"
                    name="first_name"
                    className="form-control"
                    required
                    value={formDatas.first_name_en || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        first_name_en: e.target.value,
                      }))
                    }
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    الجنسيات
                  </label>
                  <select
                    name="nationalities"
                    className="form-control"
                    value={formDatas.nationalities || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        nationalities: e.target.value,
                      }))
                    }
                    required
                  >
                    <option value="">اختر الجنسية</option>
                    <option value="192">Saudi Arabia</option>

                    {nationalities
                      .filter((item) => item.id !== 192)
                      .map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                  </select>
                </div>

                <div className="col-12 col-lg-6 mb-3">
                  <label
                    className="form-label d-block"
                    style={{ fontWeight: "bold" }}
                  >
                    النوع
                  </label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="gender"
                      value="m"
                      checked={formDatas.gender === "m"}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          gender: e.target.value,
                        }))
                      }
                    />
                    <label className="form-check-label">ذكر</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="gender"
                      value="f"
                      checked={formDatas.gender === "f"}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          gender: e.target.value,
                        }))
                      }
                    />
                    <label className="form-check-label">أنثى</label>
                  </div>
                </div>

                {formDatas.gender === "m" && (
                  <div className="col-12 mb-3">
                    <label
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      صورة شخصية
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      name="personal_photo"
                      accept="image/*"
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          personal_photo: e.target.files[0],
                        }))
                      }
                    />
                  </div>
                )}

                <div className="col-md-6 mb-3">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    رقم الهوية
                  </label>
                  <input
                    type="text"
                    name="id_number"
                    className="form-control"
                    value={formDatas.id_number || ""}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value)) {
                        setFormData((prev) => ({
                          ...prev,
                          id_number: value,
                        }));
                      }
                    }}
                  />
                  {formDatas.id_number && (
                    <>
                      {formDatas.id_number.length !== 10 && (
                        <div className="text-danger mt-1">
                          يجب أن يكون رقم الهوية مكونًا من 10 أرقام
                        </div>
                      )}
                    </>
                  )}
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    مكان الاصدار
                  </label>
                  <input
                    type="text"
                    name="id_place"
                    className="form-control"
                    value={formDatas.id_place || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        id_place: e.target.value,
                      }))
                    }
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    تاريخ الميلاد
                  </label>
                  <input
                    type="date"
                    name="birth_date"
                    className="form-control"
                    value={formDatas.birth_date || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        birth_date: e.target.value,
                      }))
                    }
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    رقم الهاتف
                  </label>
                  <input
                    type="tel"
                    name="phone"
                    className="form-control"
                    required
                    value={formDatas.phone || ""}
                    onChange={(e) => {
                      const value = e.target.value;

                      if (/^\d*$/.test(value)) {
                        setFormData((prev) => ({
                          ...prev,
                          phone: value,
                        }));
                      }
                    }}
                  />
                  {formDatas.phone && formDatas.phone.length !== 10 && (
                    <div className="text-danger mt-1">
                      يجب أن يكون رقم الهاتف مكونًا من 10 أرقام
                    </div>
                  )}
                </div>

                <div className="col-6 mb-3">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    هل لديك عمل حالياً؟
                  </label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="hasJob"
                      value="yes"
                      checked={hasJob === "yes"}
                      onChange={(e) => setHasJob(e.target.value)}
                    />
                    <label className="form-check-label">نعم</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="hasJob"
                      value="no"
                      checked={hasJob === "no"}
                      onChange={(e) => setHasJob(e.target.value)}
                    />
                    <label className="form-check-label">لا</label>
                  </div>
                </div>

                {hasJob === "yes" && (
                  <div className="col-12 mb-3">
                    <label
                      className="form-label"
                      style={{ fontWeight: "bold" }}
                    >
                      مرفق باسم موافقة جهة العمل{" "}
                    </label>
                    <input
                      type="file"
                      className="form-control"
                      name="work_permission"
                      accept=".pdf,.jpg,.png"
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          work_permission: e.target.files[0],
                        }))
                      }
                    />
                  </div>
                )}

                <div className="col-6 mb-3">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    هل انت من ذوي الاحتياجات الخاصة
                  </label>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="Health_status"
                      value="yes"
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          Health_status: e.target.value,
                        }))
                      }
                    />
                    <label className="form-check-label">نعم</label>
                  </div>
                  <div className="form-check form-check-inline">
                    <input
                      className="form-check-input"
                      type="radio"
                      name="Health_status"
                      value="no"
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          Health_status: e.target.value,
                        }))
                      }
                    />
                    <label className="form-check-label">لا</label>
                  </div>
                </div>

                <div className="col-12 mb-3">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    البريد الإلكتروني
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    required
                    value={formDatas.email || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        email: e.target.value,
                      }))
                    }
                  />

                  <div className="col-12 text-start mt-4">
                    <button
                      type="button"
                      className="btn btn px-5"
                      style={{ background: "rgb(48, 78, 80)", color: "#fff" }}
                      onClick={handleNextStep}
                    >
                      التالي
                    </button>
                  </div>
                </div>
              </>
            )}
            {step === 2 && (
              <>
                <h4
                  style={{
                    background: "#304E50",
                    padding: "10px",
                    color: "#fff",
                  }}
                >
                  البيانات الدراسية
                </h4>

                <div className="col-md-6 mb-3">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    المدينة
                  </label>
                  <input
                    type="text"
                    name="city"
                    className="form-control"
                    value={formDatas.city || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, city: e.target.value }))
                    }
                  />
                </div>

                <div className="col-md-6 mb-3">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    نوع المؤهل
                  </label>
                  <select
                    name="qualification_type"
                    className="form-control"
                    value={formDatas.qualification_type || ""}
                    onChange={(e) =>
                      setFormData((prev) => ({
                        ...prev,
                        qualification_type: e.target.value,
                      }))
                    }
                  >
                    <option value="">-- اختر --</option>
                    <option value="secondary">ثانوي</option>
                    <option value="university">جامعي</option>
                  </select>
                </div>

                {formDatas.qualification_type === "secondary" && (
                  <>
                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        المدرسة
                      </label>
                      <input
                        type="text"
                        name="school"
                        className="form-control"
                        value={formDatas.school || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            school: e.target.value,
                          }))
                        }
                      />
                    </div>
                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        النسبة في الثانوية العامة
                      </label>
                      <input
                        type="number"
                        name="average"
                        min={0}
                        max={100}
                        className="form-control"
                        value={formDatas.average || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            average: e.target.value,
                          }))
                        }
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        التخصص
                      </label>
                      <select
                        name="specialization"
                        className="form-control"
                        value={formDatas.specialization || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            specialization: e.target.value,
                          }))
                        }
                      >
                        {specialization.map((item) => (
                          <option value={item.id}>{item.name}</option>
                        ))}
                      </select>
                    </div>

                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        نسبة امتحان التحصيلي
                      </label>
                      <input
                        type="number"
                        name="summative_assessment"
                        className="form-control"
                        value={formDatas.summative_assessment || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            summative_assessment: e.target.value,
                          }))
                        }
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        النسبة في امتحان القدرات
                      </label>
                      <input
                        type="number"
                        name="ability_grade"
                        className="form-control"
                        value={formDatas.ability_grade || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            ability_grade: e.target.value,
                          }))
                        }
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        إرفاق مستندات الاختبار التحصيلي
                      </label>
                      <input
                        type="file"
                        name="file"
                        className="form-control"
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            file: e.target.files[0],
                          }))
                        }
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        إرفاق مستندات الثانوية العامة
                      </label>
                      <input
                        type="file"
                        name="hs_cert_picture_id"
                        className="form-control"
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            hs_cert_picture_id: e.target.files[0],
                          }))
                        }
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        إرفاق مستندات اختبار القدرات
                      </label>
                      <input
                        type="file"
                        name="ability"
                        className="form-control"
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            ability: e.target.files[0],
                          }))
                        }
                      />
                    </div>
                  </>
                )}

                {formDatas.qualification_type === "university" && (
                  <>
                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        نوع المعدل
                      </label>
                      <select
                        name="pg_type"
                        className="form-control"
                        value={formDatas.pg_type || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            pg_type: e.target.value,
                            average: "",
                          }))
                        }
                      >
                        <option value="">-- اختر --</option>
                        <option value="4">4</option>
                        <option value="5">5</option>
                      </select>
                    </div>

                    {formDatas.pg_type && (
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          style={{ fontWeight: "bold" }}
                        >
                          المعدل الجامعي
                        </label>
                        <input
                          type="number"
                          name="average"
                          min={0}
                          max={parseInt(formDatas.pg_type)}
                          step={0.1}
                          value={formDatas.average || ""}
                          onChange={(e) => {
                            const value = parseFloat(e.target.value);
                            const max = parseInt(formDatas.pg_type);
                            if (value <= max) {
                              setFormData((prev) => ({
                                ...prev,
                                average: e.target.value,
                              }));
                            }
                          }}
                          className={`form-control ${
                            averageError ? "is-invalid" : ""
                          }`}
                          onBlur={validateAverage}
                        />
                      </div>
                    )}

                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        تاريخ التخرج
                      </label>
                      <input
                        type="date"
                        name="graduation_date"
                        className="form-control"
                        value={formDatas.graduation_date || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            graduation_date: e.target.value,
                          }))
                        }
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        الجامعة
                      </label>
                      <input
                        type="text"
                        name="university"
                        className="form-control"
                        value={formDatas.university || ""}
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            university: e.target.value,
                          }))
                        }
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        الشهاده الجامعيه
                      </label>
                      <input
                        type="file"
                        name="university_document"
                        className="form-control"
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            university_document: e.target.files[0],
                          }))
                        }
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        السجل الاكاديمي
                      </label>
                      <input
                        type="file"
                        name="academia_document"
                        className="form-control"
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            academia_document: e.target.files[0],
                          }))
                        }
                      />
                    </div>

                    <div className="col-md-6 mb-3">
                      <label
                        className="form-label"
                        style={{ fontWeight: "bold" }}
                      >
                        وصف المقررات
                      </label>
                      <input
                        type="file"
                        name="supjects_desc"
                        className="form-control"
                        onChange={(e) =>
                          setFormData((prev) => ({
                            ...prev,
                            supjects_desc: e.target.files[0],
                          }))
                        }
                      />
                    </div>
                  </>
                )}

                <div className="col-12 mt-4">
                  <div className="d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn btn-secondary px-5"
                      onClick={() => setStep(1)}
                    >
                      الرجوع
                    </button>

                    <button
                      type="button"
                      className="btn btn px-5"
                      style={{ background: "rgb(48, 78, 80)", color: "#fff" }}
                      onClick={handleNextStep}
                    >
                      التالي
                    </button>
                  </div>
                </div>
              </>
            )}
            {step === 3 && (
              <>
                <h4
                  style={{
                    background: "#304E50",
                    padding: "10px",
                    color: "#fff",
                  }}
                >
                  تقديم الرغبات{" "}
                </h4>

                <div className="col-md-12 mb-3 mt-4">
                  <label className="form-label" style={{ fontWeight: "bold" }}>
                    البرامج المتاحه للتقديم
                  </label>
                  <div className="d-flex gap-2">
                    <select
                      className="form-control text-black bg-white"
                      value={selectedCollege}
                      onChange={(e) => setSelectedCollege(e.target.value)}
                    >
                      <option value="">-- اختر البرنامج --</option>
                      {colleges.map((item) => (
                        <option key={item.id} value={item.id}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleAddCollege}
                    >
                      إضافة
                    </button>
                  </div>
                  <span className="text-warning" style={{ fontSize: "13px" }}>
                    يرجى منكم اختيار ثلاث رغبات كحد أقصى و رغبتين كحد ادنى من
                    الخيارات المتاحة، مع ترتيبها بحسب الأولوية (من الأعلى إلى
                    الأدنى). ستُؤخذ هذه الرغبات بعين الاعتبار عند توزيع المقاعد
                    أو الفرص، لذا يرجى التحديد بدقة ووفقاً لتفضيلاتكم الشخصية
                    والأكاديمية
                  </span>
                </div>

                {selectedCourses.length > 0 && (
                  <div className="col-md-12 mt-3">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>البرنامج</th>
                          <th>إزالة</th>
                        </tr>
                      </thead>
                      <tbody>
                        {selectedCourses.map((college, index) => (
                          <tr key={college.id}>
                            <td>{index + 1}</td>
                            <td>{college.name}</td>
                            <td>
                              <button
                                type="button"
                                className="btn btn-danger btn-sm"
                                onClick={() => handleRemoveCollege(college.id)}
                              >
                                إزالة
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}

                <div className="col-md-12 mt-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="termsCheck"
                      checked={acceptedTerms}
                      onChange={(e) => setAcceptedTerms(e.target.checked)}
                    />
                    <label className="form-check-label" htmlFor="termsCheck">
                      أُقر بأنني قرأت ووافقت على{" "}
                      <strong>الشروط والأحكام</strong> الخاصة بالتسجيل في
                      الجامعة.
                    </label>
                  </div>
                </div>

                <div className="col-12 mt-4">
                  <div className="d-flex justify-content-between">
                    <button
                      type="button"
                      className="btn btn-secondary px-5"
                      onClick={() => setStep(2)}
                    >
                      الرجوع
                    </button>

                    <button
                      type="submit"
                      className="btn btn px-5"
                      style={{ background: "rgb(48, 78, 80)", color: "#fff" }}
                      disabled={
                        isSubmitting ||
                        !acceptedTerms ||
                        selectedCourses.length < 2
                      }
                    >
                      {isSubmitting ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          جاري الإرسال...
                        </>
                      ) : (
                        "إرسال"
                      )}
                    </button>
                  </div>
                </div>
              </>
            )}
          </div>
        </form>
      </div>
      <ToastContainer
        position="top-center"
        rtl
        autoClose={8000}
        toastClassName="custom-toast"
        bodyClassName="custom-toast-body"
        style={{ fontFamily: "Cairo" }}
      />
    </>
  );
};

export default RegisterPage;